import { mapGetters, mapActions } from 'vuex'
import MobileDetect from 'mobile-detect'
import turf from 'turf'
import CONSTANT from '@/constants/constant.js'
export default {
	data () {
		return {
			store: {
				lat: CONSTANT.STORE.LOCATION.LAT,
				lng: CONSTANT.STORE.LOCATION.LNG,
				distance: CONSTANT.STORE.VALID.DISTANCE
			}
		}
	},
	computed: {
		// getters
		...mapGetters({
			navigator: 'Navigator/getNavigator'
		})
	},
	methods: {
		// dispatch
		...mapActions({
			$_navigatorMixin_set: 'Navigator/setNavigator'
		}),
		/**
		 * ディスプレイモード(PWAモード)の確認
		 * @params {String} cbName コールバックの関数名
		 */
		$_navigatorMixin_detect () {
			const values = {}
			const userAgent = navigator.userAgent || navigator.vendor || window.opera
			const userAgentList = {
				Android: 'AndroidOS',
				iOS: 'iOS'
			}
			const md = new MobileDetect(userAgent)

			values.standalone = window.matchMedia('(display-mode: standalone)').matches
			Object.keys(userAgentList).forEach((key) => {
				if (md.is(userAgentList[key])) {
					values.userAgent = key
				}
			})
			values.version = md.versionStr(values.userAgent)
			values.mobile = md.mobile()
			values.isAvailable = this.$_navigatorMixin_checkIsAvailable(values)

			this.$_navigatorMixin_set(values)
			this.$_navigatorMixin_preventBackButton(values)
		},
		$_navigatorMixin_checkIsAvailable (values) {
			const { standalone, version, userAgent } = values
			if (
				userAgent !== 'iOS' ||
				!standalone
			) {
				return true
			}

			const v = version.split('_')
			// iOSでバージョン 12.2 以下の端末はスタンドアローンモードでの利用不可
			// また 13.1.x でもバグを確認しているので対象外とする
			if (v[0] < 12) {
				return false
			} else if (v[0] === 12) {
				return v[1] > 1
			} else if (v[0] === 13) {
				return v[1] > 1
			} else {
				return true
			}
		},
		$_navigatorMixin_preventBackButton (values) {
			if (values.userAgent === 'Android') {
				document.addEventListener('backbutton', e => {
					e.preventDefault()
				}, false)
			} else if (values.userAgent === 'iOS') {
				history.pushState(null, null, location.href)
				window.onpopstate = (event) => {
					history.go(1)
				}
			}
		},
		$_navigatorMixin_getMyLocation () {
			const options = {
				enableHighAccuracy: true,
				timeout: 8 * 1000,
				maximumAge: 0
			}
			const deferred = new Promise((resolve, reject) => {
				if (!navigator.geolocation) {
					return reject(new Error('位置情報を利用できません'))
				}
				navigator.geolocation.getCurrentPosition(
					position => {
						resolve(position)
					},
					// 取得失敗した場合
					error => {
						const message = error.message === 'User denied Geolocation'
							? 'GPSの設定を許可にしてから再度お試しください'
							: '位置情報を取得できませんでした'

						reject(new Error(message))
					},
					options
				)
			})
			return deferred
		},
		$_navigatorMixin_checkIntersection (myLocation) {
			const deferred = new Promise((resolve, reject) => {
				const { latitude, longitude } = myLocation.coords
				const { lat, lng, distance } = this.store
				const basePoint = turf.point([lat, lng])
				const myPoint = turf.point([
					latitude,
					longitude
				])
				const buffered = turf.buffer(basePoint, distance)
				const intersection = turf.intersect(buffered, myPoint)

				if (intersection) {
					resolve()
				} else {
					reject(new Error('店舗近くへ移動してください（店舗近辺でのみ決済や解錠を行えます）'))
				}
			})
			return deferred
		}
	}
}
